<template>
  <section class="login-page app-content d-flex align-items-center">
    <div class="container">
      <div v-if="parentVersion" class="row justify-content-center">
        <div class="form-container">
          <img class="login-logo" src="~assets/img/hallo_eltern.png" alt="">
          <p class="login-text">hallo! ist die optimale, sichere<br>
            Kommunikationslösung zur Klassenpinnwand.</p>
          <form @submit.prevent="submit" id="login-form" class="auth-form">
            <alert class="login-alert" :success="alert.success" :error="alert.error"></alert>
            <div class="form-group">
              <form-error :errors='errors' :attribute="'email'">
                <input v-model="user.mail"  placeholder="E-Mail"/>
              </form-error>
              <i class="fa fa-user"></i>
            </div>
            <div class="form-group">
              <form-error :errors='errors' :attribute="'password'">
                <input class="" v-model="user.password" type="password" placeholder="Passwort"/>
              </form-error>
              <i class="fa fa-lock"></i>
              <p class="text-right btn-cursor" v-b-modal.modal-reset-password>Passwort vergessen?</p>
            </div>
            <button class="btn-submit" type="submit" form="login-form" value="Submit" :disabled="processing">
              <clip-loader :loading="processing" :color="'white'" :size="'17px'"></clip-loader>
              <span v-if="!processing">Anmelden</span>
            </button>
          </form>
          <div class="text-center mt-4">
            <router-link :to="{ name: 'registration' }" class="d-inline-block underlined-link">Registrieren</router-link>
          </div>
        </div>
        <b-modal @ok="resetForm()" ref="modalResetPassword" id="modal-reset-password" size="md" centered class="app-modals" title="Passwort zurücksetzen" hide-footer>
          <password-reset :showModalMessage="showModalMessage" />
        </b-modal>
      </div>
      <div v-else class="row justify-content-center">
        <div class="col-12 text-center">
          <img class="login-logo" src="~assets/img/hallo_lehrer.png" alt="" style="width: 200px">
        </div>
        <div class="col-12 text-center mt-4">
          <a :href="klassenpinnwandUrl" class="btn-gradient btn-rounded" style="font-size: 18px;">
            <span class="px-5">zum Login</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// API
import account from '@/api/v1/account';
// Components
import Alert from '@/components/Helpers/Alert';
import FormError from '@/components/Helpers/FormError';
import PasswordReset from '@/components/Account/Reset';
// Mixins
import alert from '@/mixins/alert';

export default {
  components: { Alert, FormError, PasswordReset },
  mixins: [alert],
  data() {
    return {
      user: {
        teacher: false,
      },
      password: '',
      processing: false,
      showModalMessage: false
    };
  },
  computed: {
    parentVersion() {
      return !process.env.TEACHER;
    },
    klassenpinnwandUrl() {
      return process.env.KLASSENPINNWAND_URL;
    },
  },
  methods: {
    submit() {
      this.clearAlerts();
      this.processing = true;
      const succ = () => {
        this.alert.success = 'Success!';
        this.processing = false;
        this.$bus.loginSuccess();
      };
      const err = (response) => {
        if (response.data.detailresponse && !response.data.detailresponse.userdata.validated) {
          this.$router.push({ name: 'email_confirmation' });
        }
        if (response.data.statuscode === 20 || !this.user.password || !this.user.mail) {
          this.alert.error =
            'Zugangsdaten falsch. Bitte überprüfen Sie Ihren Benutzernamen und Ihr Passwort und versuchen es erneut.';
        }
        this.processing = false;
      };
      account.parentLogin(this.user, succ, err);
    },
    resetForm(){
      this.showModalMessage = false;
    }
  },
  created() {
    if (!this.parentVersion && !account.user.isAuthenticated() && account.user.getPinboard()) {
      location.href = process.env.SSO_LOGIN_URL;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Auth/Login.vue